import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { FaExclamationTriangle, FaHome, FaArrowLeft } from 'react-icons/fa';
import './ErrorPages.css';

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="error-page-wrapper">
      <Container className="error-container">
        <div className="error-content">
          {/* Icon */}
          <div className="error-icon-wrapper">
            <FaExclamationTriangle className="error-icon not-found-icon" />
          </div>

          {/* Error Code */}
          <h1 className="error-code">404</h1>

          {/* Error Message */}
          <h2 className="error-title">Page Not Found</h2>
          <p className="error-description">
            The page you're looking for doesn't exist or has been moved.
            <br />
            <code className="error-path">{location.pathname}</code>
          </p>

          {/* Action Buttons */}
          <div className="error-actions">
            <Button
              variant="primary"
              size="lg"
              onClick={() => navigate('/')}
              className="error-btn error-btn-primary"
            >
              <FaHome className="me-2" />
              Go to Home
            </Button>
            <Button
              variant="outline-secondary"
              size="lg"
              onClick={() => navigate(-1)}
              className="error-btn error-btn-secondary"
            >
              <FaArrowLeft className="me-2" />
              Go Back
            </Button>
          </div>

          {/* Help Text */}
          <div className="error-help">
            <p className="text-muted">
              If you think this is a mistake, please contact support or check the URL.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotFound;
